/**
 * Single source of truth for EMIBOOK product assets and links.
 *
 * Every entry below points at a real screenshot that ships in /public/assets.
 * If a screen doesn't exist in the repository, it isn't listed here — nothing
 * on the marketing site should render an invented product interface.
 */

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=in.emibook.app&hl=en";

export const SCREENS = {
  // Home: Orders / Customers tiles, profile, support.
  dashboard: "assets/g.jpg",
  // Registration form: name, mobile, email, PIN — how a customer record starts.
  register: "assets/img/f.jpg",
  // Orders list with per-entry amount.
  orders: "assets/img/c.jpg",
  // Single settled order record.
  orderRecord: "assets/img/d.jpg",
  // Order/payment entry: amount, pay, transaction number, receipt upload.
  payment: "assets/img/e.jpg",
  // Sign-in.
  login: "assets/img/a.jpg",
  // Support: terms, email, WhatsApp, phone.
  support: "assets/h.jpg",
};
